import React from "react";

const HomeSliderSection = ({ sliders }) => {
    // যদি ডাটা না থাকে তবে ফলব্যাক ডেটা ব্যবহার করা হবে
    const currentSlider = sliders && sliders.length > 0 ? sliders[0] : {};

    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL || "";

    // ডাইনামিক ফিল্ডগুলো
    const licenseNo = currentSlider?.license_no || "RL LICENSE NO: 2908";
    const titleFirst = currentSlider?.title_first || "TARIF OVERSEAS";
    const titleColored = currentSlider?.title_colored || "LIMITED";
    const subtitle = currentSlider?.subtitle || "Trusted Global Overseas Recruitment Partner from Bangladesh";
    const description = currentSlider?.description || "22+ Years of Excellence in Connecting Skilled & Semi-Skilled Manpower to Middle East & Europe.";

    // ডানপাশের মূল ব্যানার ইমেজ
    const bannerImage = currentSlider?.image
        ? `${backendBaseUrl}${currentSlider.image}`
        : "https://i.ibb.co/3W83s0m/globe-logo-placeholder.png"; // ফলব্যাক ইমেজ

    return (
        <section
            className="position-relative overflow-hidden text-white"
            style={{
                backgroundColor: '#0b132b',
                minHeight: '550px',
                display: 'flex',
                alignItems: 'center',
                paddingTop: '80px',
                paddingBottom: '80px'
            }}
        >
            <div className="container">
                <div className="row align-items-center g-5">
                    {/* Left Side: Title & Info */}
                    <div className="col-lg-7 col-md-12">
                        {/* License Badge */}
                        <div className="mb-3">
                            <span
                                className="badge px-3 py-2 fw-normal text-uppercase"
                                style={{
                                    backgroundColor: 'rgba(30, 58, 138, 0.6)',
                                    border: '1px solid #2563eb',
                                    borderRadius: '30px',
                                    fontSize: '13px',
                                    letterSpacing: '1px',
                                    color: '#93c5fd'
                                }}
                            >
                                {licenseNo}
                            </span>
                        </div>

                        {/* Main Title */}
                        <h1
                            className="fw-bold mb-3 text-uppercase"
                            style={{
                                fontSize: 'clamp(32px, 5vw, 52px)',
                                lineHeight: '1.2',
                                letterSpacing: '0.5px',
                                color: '#ffffff'
                            }}
                        >
                            {titleFirst} <br />
                            <span style={{ color: '#3b82f6' }}>{titleColored}</span>
                        </h1>

                        {/* Subtitle */}
                        <p className="text-light opacity-75 mb-3" style={{ fontSize: '16px' }}>
                            {subtitle}
                        </p>

                        {/* Description */}
                        <p className="text-light opacity-50 mb-0" style={{ fontSize: '14px', maxWidth: '550px', lineHeight: '1.6' }}>
                            {description}
                        </p>
                    </div>

                    {/* Right Side: Dynamic Image / Banner */}
                    <div className="col-lg-5 col-md-12 text-center text-lg-end">
                        <div
                            className="position-relative overflow-hidden rounded-4 shadow-lg p-2"
                            style={{
                                backgroundColor: 'rgba(255, 255, 255, 0.03)',
                                border: '1px solid rgba(255, 255, 255, 0.1)'
                            }}
                        >
                            <img
                                src={bannerImage}
                                alt="Tarif Overseas Banner"
                                className="img-fluid rounded-3 w-100"
                                style={{
                                    maxHeight: '380px',
                                    objectFit: 'cover'
                                }}
                                onError={(e) => {
                                    e.target.src = "https://i.ibb.co/3W83s0m/globe-logo-placeholder.png";
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeSliderSection;